import {SueloCore} from './suelos-core.model';
import {Chacra} from "../chacra";

export interface SuelosCoreFormInput {
  suelos: SueloCore[];
  chacra: Chacra;
}

export interface SuelosCoreFormOutput {
  suelo: SueloCore;
  files: FileList;
}
